import React from 'react';
import TableHead from '@material-ui/core/TableHead';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import AddIcon from '@material-ui/icons/Add';
import Typography from '@material-ui/core/Typography';
import { getDateFormat } from '../../utils/suitableDate';
import Button from '../Button';
import Modal from '../Modal';
import Spinner from '../Spinner';
import { mainColor, UNIT } from '../../constants';
import { getDataFromStripe, getDataFromStripeDetails } from './DetailsPayouts.services';

class DetailsPayouts extends React.PureComponent {
  constructor() {
    super();
    this.state = {};
  }

  async componentDidMount() {
    const balances = await getDataFromStripe();
    this.setState({
      balances
    });
  }

  returnSuitableState = status => {
    switch (status) {
      case 'in_transit':
        return 'En cours';
      case 'paid':
        return 'Reçu';
      default:
        return 'En cours';
    }
  };

  renderDetailsPayouts = payments => {
    const { loading } = this.state;

    return (
      <div>
        {loading || !payments ? (
          <center>
            <Spinner
              style={{
                margin: UNIT * 5,
                textAlign: 'center',
                color: `rgba(${mainColor.rgb}, 1)`,
                alignSelf: 'center'
              }}
            />
          </center>
        ) : payments.length > 0 ? (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align='center'>Montant</TableCell>
                <TableCell align='center'>Date du paiement</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {payments &&
                payments
                  .sort((a, b) => new Date(b.date) - new Date(a.date))
                  .map(payment => {
                    const { date, amount } = payment;
                    return (
                      <TableRow>
                        <TableCell align='center'>{`${parseFloat(amount).toFixed(2)} €`}</TableCell>
                        <TableCell align='center'>{getDateFormat(date)}</TableCell>
                      </TableRow>
                    );
                  })}
            </TableBody>
          </Table>
        ) : (
          <Typography>Aucune donnée disponible pour ce virement</Typography>
        )}
      </div>
    );
  };


  render() {
    const { balances, details } = this.state;
    const { isAllShops = false } = this.props;
    return (
      <div>
        {balances ? (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align='center'>Montant</TableCell>
                <TableCell align='center'>Statut</TableCell>
                <TableCell align='center'>Lancement</TableCell>
                <TableCell align='center'>Réception</TableCell>
                {!isAllShops &&
                  <TableCell align='center'>Détails</TableCell>
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {balances.map(e => {
                const modal = this.state[e.dateCreated];
                return (
                  <TableRow>
                    <TableCell align='center'>{`${e.value.toFixed(2)} €`}</TableCell>
                    <TableCell align='center'>{this.returnSuitableState(e.status)}</TableCell>
                    <TableCell align='center'>{getDateFormat(e.dateCreated)}</TableCell>
                    <TableCell align='center'>{getDateFormat(e.dateArrival)}</TableCell>
                    {!isAllShops &&
                      <TableCell align='center'>
                        <Button color='link' onClick={() => {
                          this.setState({ [e.dateCreated]: true });
                          if (e?.automatic) {
                            getDataFromStripeDetails(e?.transactionId, e.automatic, this)
                          }
                          else { this.setState({ details: [] }) }
                        }}>
                          <AddIcon />
                        </Button>
                      </TableCell>
                    }
                    <Modal
                      isOpen={modal}
                      fixed
                      header
                      onClose={() => this.setState({ [e.dateCreated]: false })}
                      title={`Détails du virement de ${e.value.toFixed(2) || 0} €`}
                      onClick={() => {
                        this.setState({ [e.dateCreated]: false });
                      }}
                      handleClose={() => {
                        this.setState({ [e.dateCreated]: false, details: null });
                      }}
                    >
                      <p>{this.renderDetailsPayouts(details)}</p>
                    </Modal>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        ) : (
          <center>
            <Spinner
              style={{
                margin: UNIT * 5,
                textAlign: 'center',
                color: `rgba(${mainColor.rgb}, 1)`,
                alignSelf: 'center'
              }}
            />
          </center>
        )}
      </div>
    );
  }
}

export default DetailsPayouts;
